const MODAL_BACKGROUND_CLASS = 'modal-background';
const MODAL_CONTENT_CLASS = 'modal-content';

const createModalStyles = (): HTMLStyleElement => {
  const styleElement = document.createElement('style') as HTMLStyleElement;
  const cssContent = document.createTextNode(`
        .${MODAL_BACKGROUND_CLASS} {
            display: block; 
            position: fixed; /* Stay in place */
            z-index: 1000; /* Sit on top */
            left: 0;
            top: 0;
            width: 100%; /* Full width */
            height: 100%; /* Full height */
            overflow: auto; /* Enable scroll if needed */
            background-color: rgb(0,0,0); /* Fallback color */
            background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
        }
    
        .${MODAL_CONTENT_CLASS} {
            background-color: #fefefe;
            margin: 2% auto; 
            padding: 0px;
            border: 1px solid #888;
            height: 95%;
            max-width: 95%;
            position: relative;
            box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
            animation-name: animatetop;
            animation-duration: 0.4s
        }
    
        @keyframes animatetop {
            from {top: -300px; opacity: 0}
            to {top: 0; opacity: 1}
          }
      `);
  styleElement.appendChild(cssContent);
  return styleElement;
};

export const createModal = <T extends Node>(modalId: string, htmlModalContent: T): HTMLDivElement => {
  const modalParent = document.createElement('div') as HTMLDivElement;
  modalParent.appendChild(createModalStyles());
  modalParent.id = modalId;
  const modalContainer = document.createElement('div') as HTMLDivElement;
  modalContainer.id = `${modalId}-modal-container`;
  modalContainer.classList.add(MODAL_BACKGROUND_CLASS);
  modalParent.appendChild(modalContainer);

  const modalContent = document.createElement('div') as HTMLDivElement;
  modalContent.id = `${modalId}-modal-content`;
  modalContent.classList.add(MODAL_CONTENT_CLASS);
  modalContainer.appendChild(modalContent);
  modalContent.appendChild(htmlModalContent);
  return modalParent;
};

export const showModal = (modalId: string): void => {
  (document.getElementById(modalId) as HTMLDivElement).style.display = 'block';
};

export const hideModal = (modalId: string): void => {
  (document.getElementById(modalId) as HTMLDivElement).style.display = 'none';
};
